import styled from "styled-components";
import Link from "../../../styles/shared/Links/Link";
import { colors } from "../../../styles/variables/colors";
import { fonts } from "../../../styles/variables/fonts";

export const Label = styled.p`
  font-family: ${fonts.nunito};
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  text-transform: uppercase;
  color: ${colors.infoLabel};
`;

export const Name = styled.h3`
  font-family: ${fonts.sourceSansPro};
  margin: 1rem 0;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: ${colors.infoName};
`;

export const Address = styled.p`
  font-family: ${fonts.nunito};
  margin: 0;
  font-weight: 300;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: ${colors.infoAddress};
`;

export const InfoWindowWrap = styled.div`
  text-align: center;
`;
